/** Standard NPI identifier system */
export const NPI_SYSTEM = 'http://hl7.org/fhir/sid/us-npi';

/** Stedi payer network identifier system (used on insurer Organization resources) */
export const STEDI_PAYER_NETWORK_SYSTEM = 'https://www.stedi.com/healthcare/network';

/** Stedi eligibility response identifier system (used on CoverageEligibilityResponse and DocumentReference) */
export const STEDI_ELIGIBILITY_RESPONSE_SYSTEM = 'http://stedi.com/eligibility-response';

/** Task code system for batch eligibility tracking Tasks */
export const BATCH_ELIGIBILITY_TASK_SYSTEM = 'http://polarissleep.com/task-types';

/** Task code value for batch eligibility tracking Tasks */
export const BATCH_ELIGIBILITY_TASK_CODE = 'batch-eligibility-check';

/** Identifier system for storing Stedi batchId on Task resources */
export const STEDI_BATCH_IDENTIFIER_SYSTEM = 'https://www.stedi.com/batch-eligibility';
